<div class="container-login justify-content-center align-items-center">
  <div class="mx-auto form-login container-fluid">
    <mat-card class="center-block container-login-form">
      <mat-card-header class="justify-content-center header-login">
        <mat-card-title>Recuperar Contraseña</mat-card-title>
        <div class="dropdown-divider"></div>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="d-flex flex-column justify-content-between py-3">
        <p>
          The Shiba Inu is the smallest of the six original and distinct spitz
          breeds of dog from Japan. A small, agile dog that copes very well with
          mountainous terrain, the Shiba Inu was originally bred for hunting.
        </p>
        <div action="" class="d-flex flex-column py-2 form-login-input ">
          <label for="username" class="title-item"> Usuario</label>
          <mat-label>Escriba su usuario</mat-label>
          <input
            matInput
            id="username"
            class="input-login"
            type="text"
            [formControl]="myControl"
            (keyup.enter)="myControl.valid ? onSubmit() : null"
          />
          <mat-error
            *ngIf="myControl.invalid && (myControl.dirty || myControl.touched)"
            >{{ getErrorMessage() }}</mat-error
          >
        </div>
      </mat-card-content>
      <mat-card-footer
        class="d-flex flex-column justify-content-center py-3 footer-login"
      >
        <button
          mat-button
          id="submit"
          type="submit"
          class="button-primary-event border-box"
          [disabled]="myControl.invalid || isSubmitting"
          (click)="onSubmit()"
        >
          ENVIAR
        </button>
        <div class="cart-customer t-c py-2"></div>
      </mat-card-footer>
    </mat-card>
  </div>
</div>
